<div
  class="surface-low flex min-h-10 cursor-pointer items-center justify-center rounded-full"
>
  @if (mobile()) {
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      (menuOpened)="onMenuOpened()"
      (menuClosed)="menuOpen.set(false)"
    >
      <mat-icon>{{ options().mobileIcon || 'menu' }}</mat-icon>
    </button>
  } @else {
    <div
      [matMenuTriggerFor]="menu"
      (menuOpened)="onMenuOpened()"
      (menuClosed)="menuOpen.set(false)"
      class="sia-hover mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base relative min-h-10 w-full cursor-pointer flex-row items-center gap-2 overflow-hidden whitespace-nowrap"
      [class]="
        getMarkerType(selectedItem()?.marker)
          ? 'text-left'
          : 'justify-center text-center'
      "
      matRipple
      [siaTooltip]="displayValue()"
      [disableTranslation]="!!options().translateData"
      [disableMobile]="true"
      #button
    >
      @if (selectedItem()) {
        @switch (getMarkerType(selectedItem()?.marker)) {
          @case ('vectorImg') {
            <div
              class="flex h-5 w-5 flex-shrink-0 items-center justify-center"
              [innerHTML]="selectedItem()?.marker | safeHtml"
            ></div>
          }
          @case ('color') {
            <div
              class="h-3 w-3 flex-shrink-0 rounded-full"
              [style.background-color]="selectedItem()?.marker"
            ></div>
          }
          @case ('icon') {
            <mat-icon>{{ selectedItem()?.marker }}</mat-icon>
          }
        }
      }

      <span class="flex-grow truncate text-sm font-medium">
        {{
          !!options().translateData
            ? (displayValue() | siaTranslate)
            : displayValue()
        }}
      </span>
      @if (!useShortDescriptionComputed()) {
        <mat-icon
          class="!m-0 flex-shrink-0 !text-center transition-transform duration-300"
          [class.rotate-180]="menuOpen()"
          >arrow_drop_down</mat-icon
        >
      }
    </div>
  }
</div>

<mat-menu #menu="matMenu" class="button-select-box-menu">
  @if (computedRemoveSelection()) {
    <button
      mat-menu-item
      (click)="clearValue()"
      style="color: var(--sia-error) !important"
    >
      <mat-icon style="color: inherit !important">delete</mat-icon>
      <span>{{ computedRemoveSelectionLabel() }}</span>
    </button>
    <mat-divider></mat-divider>
  }

  @if (
    computedExtraButtonPosition() === 'top' &&
    computedExtraButtonLabel() &&
    extraIcon()
  ) {
    <button
      mat-menu-item
      (click)="onExtraButtonClick()"
      [style]="extraIconStyle()"
    >
      <mat-icon [style]="extraIconStyle()">{{ extraIcon() }}</mat-icon>
      <span>{{
        !!options().translateData
          ? (computedExtraButtonLabel() | siaTranslate)
          : computedExtraButtonLabel()
      }}</span>
    </button>
    <mat-divider></mat-divider>
  }

  @if (loading()) {
    <div class="flex justify-center p-4">
      <mat-icon class="animate-spin">sync</mat-icon>
    </div>
  } @else {
    @if (showSearch()) {
      <div
        class="border-b border-gray-200 px-3 py-2"
        (click)="$event.stopPropagation()"
        (keydown)="$event.key !== 'Escape' ? $event.stopPropagation() : null"
      >
        <div
          class="flex items-center gap-2 rounded border border-gray-300 bg-gray-50 px-2 py-1.5"
        >
          <mat-icon class="!text-base opacity-50">search</mat-icon>
          <input
            class="flex-1 bg-transparent text-sm outline-none placeholder:opacity-50"
            type="text"
            placeholder="Cerca..."
            [value]="searchQuery()"
            (input)="searchQuery.set($any($event.target).value)"
          />
          @if (searchQuery()) {
            <button
              class="flex items-center opacity-50 hover:opacity-100"
              type="button"
              (click)="searchQuery.set(''); $event.stopPropagation()"
            >
              <mat-icon class="!text-base">close</mat-icon>
            </button>
          }
        </div>
      </div>
    }
    @if (filteredDataSource().length === 0) {
      <div class="text-outline p-4 text-center text-sm">
        {{ 'Nessun risultato' | siaTranslate }}
      </div>
    } @else {
      <cdk-virtual-scroll-viewport
        itemSize="48"
        [style.height.px]="viewportHeight()"
        minBufferPx="400"
        maxBufferPx="800"
        class="w-full"
        (wheel)="$event.stopPropagation()"
      >
        <button
          *cdkVirtualFor="let item of filteredDataSource()"
          mat-menu-item
          (click)="selectValue(item)"
          [disabled]="item.id === value()"
          [class.selected]="item.id === value()"
          [style.background-color]="
            item.id === value()
              ? 'var(--mdc-theme-primary-container, var(--mat-sys-primary-container))'
              : ''
          "
          [style.color]="
            item.id === value()
              ? 'var(--mdc-theme-on-primary-container, var(--mat-sys-on-primary-container))'
              : ''
          "
          [style.font-weight]="item.id === value() ? '600' : ''"
          [style.border-left]="
            item.id === value()
              ? '4px solid var(--mdc-theme-primary, var(--mat-sys-primary))'
              : ''
          "
          [style.opacity]="item.id === value() ? '1' : ''"
        >
          <div
            class="flex w-full min-w-0 flex-row items-center justify-between gap-2"
          >
            <div class="flex min-w-0 items-center gap-2 overflow-hidden">
              @if (item.marker) {
                @switch (getMarkerType(item.marker)) {
                  @case ('vectorImg') {
                    <div
                      class="flex h-5 w-5 items-center justify-center"
                      [innerHTML]="item.marker | safeHtml"
                    ></div>
                  }
                  @case ('color') {
                    <div
                      class="h-3 w-3 flex-shrink-0 rounded-full"
                      [style.background-color]="item.marker"
                    ></div>
                  }
                  @case ('icon') {
                    <mat-icon class="flex-shrink-0">{{ item.marker }}</mat-icon>
                  }
                }
              } @else {
                <div class="w-4"></div>
              }
              <span
                class="flex-1 truncate"
                [siaTooltip]="item.description"
                [disableTranslation]="!!options().translateData"
                [disableMobile]="true"
                >{{
                  !!options().translateData
                    ? (item.description | siaTranslate)
                    : item.description
                }}</span
              >
            </div>
          </div>
        </button>
      </cdk-virtual-scroll-viewport>
    }
  }

  @if (
    computedExtraButtonPosition() === 'bottom' &&
    computedExtraButtonLabel() &&
    extraIcon()
  ) {
    <mat-divider></mat-divider>
    <button
      mat-menu-item
      (click)="onExtraButtonClick()"
      [style]="extraIconStyle()"
    >
      <mat-icon [style]="extraIconStyle()">{{ extraIcon() }}</mat-icon>
      <span>{{
        !!options().translateData
          ? (computedExtraButtonLabel() | siaTranslate)
          : computedExtraButtonLabel()
      }}</span>
    </button>
  }
</mat-menu>
